import { Eye } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { setTenantSlug } from "@/lib/tenant";

export function DemoBanner() {
  const { user, logout } = useAuth();
  if (!user?.readonly) return null;
  const signup = async () => {
    await logout();
    setTenantSlug(null);
    window.location.href = "/cadastro";
  };
  return (
    <div className="flex flex-wrap items-center gap-3 px-4 py-3 no-print" style={{ background: "var(--brand)", color: "#fff" }} data-testid="demo-banner">
      <Eye size={16} />
      <span className="flex-1 min-w-[200px] text-sm font-semibold">Você está vendo uma demonstração · explore à vontade, nada pode ser alterado.</span>
      <button className="btn btn-sm" style={{ background: "#fff", color: "var(--brand)" }} onClick={signup} data-testid="demo-banner-signup">Criar minha conta</button>
    </div>
  );
}
